$(document).ready(function () {
  $(".faq-answer").hide();

  $(".faq-que").on("click", function () {
    let submenu = $(this).next(".faq-answer");

    if (submenu.is(":visible")) {
      submenu.slideUp();
      $(this).find(".slide-icon").removeClass("active");
    } else {
      $(".faq-answer").slideUp();
      $(".slide-icon").removeClass("active");

      submenu.slideDown();
      $(this).find(".slide-icon").addClass("active");
    }
  });
});
$(document).ready(function () {
  setTimeout(function () {
    $("#popup-overlay, #welcome-popup").fadeIn();
  }, 5000),
    $(".popup-close-btn").on("click", function () {
      $("#popup-overlay, #welcome-popup").fadeOut();
    }),
    $("#popup-overlay").on("click", function () {
      $("#popup-overlay, #welcome-popup").fadeOut();
    });
});
